import React from 'react';
import { Car } from '../../../../../../assets/images/index';
import {
  StyleWidgetIcon,
  StyledStartText,
  StyledCenterWrap,
  StyledConfigLink
} from './style';

const TrafficStart = ({ onClick }) => (
  <StyledCenterWrap>
    <StyledStartText className="TraficStart-text">
      <StyledConfigLink onClick={onClick}>Configura</StyledConfigLink> el widget
      para conocer la mejor ruta a casa o el trabajo
    </StyledStartText>
    <StyleWidgetIcon svg={Car} size="l" color="dark" />
  </StyledCenterWrap>
);

export default TrafficStart;
